<template>
  <v-sheet
    border
    rounded
  >
    <slot />
  </v-sheet>
</template>

<script setup>
  //
</script>
